import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import classNames from 'classnames';
import surveyBannerConfig from '../SurveyBanner/SurveyBannerConfig';
import { getCurrentEnvironment } from '../common/Utils';

const SurveyBanner = ({
  translations,
  surveyLink,
  eventId,
  eventEditionId,
  bannerType = 'Banner'
}) => {

  const [bannerMaximized, setBannerMaximized] = useState(true);

  const isEventExcludedForSurvey = () => {
    const env = getCurrentEnvironment();
    const environmentConfig = surveyBannerConfig[env];

    const eventIdsToExclude = environmentConfig != null ? environmentConfig['eventIdsToExclude'] : null;
    const isEventIdExcluded = eventIdsToExclude != null && eventId != null && eventIdsToExclude.includes(eventId);

    const eventEditionIdsToExclude = environmentConfig != null ? environmentConfig['eventEditionIdsToExclude'] : null;
    const isEventEditionIdExcluded = eventEditionIdsToExclude != null && eventEditionId != null && eventEditionIdsToExclude.includes(eventEditionId);

    return isEventIdExcluded || isEventEditionIdExcluded;
  };

  const isSurveyBannerAvailable = translations != null && surveyLink != null && translations.title != null && !isEventExcludedForSurvey();

  const isSurveyTypeBanner = bannerType === 'Banner';

  const onMinimizeClick = () => {
    setBannerMaximized(!bannerMaximized);
  };

  const onTitleClick = () => {
    if (!bannerMaximized)
      setBannerMaximized(true);
  };

  const getMinimizeSvg = () => {
    return (<path d="M5.55762 13.9425L6.62262 15L9.00012 12.6225L11.3776 15L12.4351 13.9425L9.00012 10.5L5.55762 13.9425ZM12.4426 4.0575L11.3776 3L9.00012 5.3775L6.62262 3L5.55762 4.0575L9.00012 7.5L12.4426 4.0575Z" fill="#808080" />);
  };

  const getMaximizeSvg = () => {
    return (<path d="M9.00012 4.3725L11.3776 6.75L12.4351 5.6925L9.00012 2.25L5.55762 5.6925L6.62262 6.75L9.00012 4.3725ZM9.00012 13.6275L6.62262 11.25L5.56512 12.3075L9.00012 15.75L12.4426 12.3075L11.3776 11.25L9.00012 13.6275Z" fill="#808080" />);
  };

  const getGTSvg = () => {
    return (<path d="M1.27869 0.5L0.221191 1.5575L3.65619 5L0.221191 8.4425L1.27869 9.5L5.77869 5L1.27869 0.5Z" fill="white" />);
  };

  const surveyLabel = (
    <div className={Classes.surveyLabelWrapper}>
      <a
        href={surveyLink}
        className={Classes.surveyLabelLink}
        data-testid='survey-label-link'
        target="_blank"
        rel="noopener noreferrer">
        {translations != null && translations.title}
      </a>
    </div>
  );

  return (
    <>
      {isSurveyBannerAvailable && (
        isSurveyTypeBanner
          ? (<div className={classNames(Classes.surveyBannerWrapper, { closed: !bannerMaximized })}>
            <div className={Classes.surveyBannerIcon}>
              <svg height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.83333 11.8833H9.66667V13.55H3.83333V11.8833ZM3.83333 8.55001H12.1667V10.2167H3.83333V8.55001ZM3.83333 5.21667H12.1667V6.88334H3.83333V5.21667ZM13.8333 1.88334H10.35C10 0.916675 9.08333 0.216675 8 0.216675C6.91667 0.216675 6 0.916675 5.65 1.88334H2.16667C2.05 1.88334 1.94167 1.89167 1.83333 1.91667C1.50833 1.98334 1.21667 2.15001 0.991667 2.37501C0.841667 2.52501 0.716667 2.70834 0.633333 2.90834C0.55 3.10001 0.5 3.31667 0.5 3.55001V15.2167C0.5 15.4417 0.55 15.6667 0.633333 15.8667C0.716667 16.0667 0.841667 16.2417 0.991667 16.4C1.21667 16.625 1.50833 16.7917 1.83333 16.8583C1.94167 16.875 2.05 16.8833 2.16667 16.8833H13.8333C14.75 16.8833 15.5 16.1333 15.5 15.2167V3.55001C15.5 2.63334 14.75 1.88334 13.8333 1.88334ZM8 1.67501C8.34167 1.67501 8.625 1.95834 8.625 2.30001C8.625 2.64167 8.34167 2.92501 8 2.92501C7.65833 2.92501 7.375 2.64167 7.375 2.30001C7.375 1.95834 7.65833 1.67501 8 1.67501ZM13.8333 15.2167H2.16667V3.55001H13.8333V15.2167Z" fill="#666666" />
              </svg>
            </div>
            <div className={Classes.surveyBannerSection}>
              <div className={Classes.surveyBannerDisplay}>
                <div className={classNames(Classes.surveyBannerTitleWrapper, { 'cut-text': !bannerMaximized })}>
                  <span className={Classes.surveyBannerTitle} onClick={onTitleClick}>
                    {translations.title}
                  </span>
                </div>
                <button
                  onClick={onMinimizeClick}
                  className={Classes.surveyBannerMinimizeBtn}
                  data-testid='survey-banner-minimize-btn'>
                  <svg width="18" height="18">
                    {bannerMaximized ? getMinimizeSvg() : getMaximizeSvg()}
                  </svg>
                </button>
              </div>
              <a
                onClick={onMinimizeClick}
                href={surveyLink}
                className={classNames(Classes.surveyBannerLink, { closed: !bannerMaximized })}
                data-testid='survey-banner-link'
                target="_blank"
                rel="noopener noreferrer">
                <svg width="18" height="18">
                  {getGTSvg()}
                </svg>
                {translations.action}
              </a>
            </div>
          </div>)
          : (typeof document !== 'undefined'
            ? ReactDOM.createPortal(surveyLabel, document.body)
            : surveyLabel)
      )}
    </>
  );
};

SurveyBanner.propTypes = {
  translations: PropTypes.object,
  surveyLink: PropTypes.string,
  eventId: PropTypes.string,
  eventEditionId: PropTypes.string,
  bannerType: PropTypes.string
};

export default SurveyBanner;
